// The domain the company runs on. Every address and URL the product shows or
// mails from is derived from it, so a domain move is this one line; a guard
// test fails on a brand domain written anywhere else.
export const brandDomain = "memoair.ai";

// Domains the company has left. Kept only for what still arrives from or links
// to them: mail sent before the move, and old dashboard links.
export const brandLegacyDomains = ["getmemoair.space", "memoair.space"];

// The one retired host browsers may still call the API from cross-origin.
export const brandLegacyAppUrl = "https://dashboard.getmemoair.space";

export const brandSiteUrl = `https://${brandDomain}`;

export const brandAppUrl = `https://app.${brandDomain}`;

export const brandSupportEmail = {
  name: "Memoair team",
  email: `hello@${brandDomain}`,
};

// Agents mail people from their own address on this domain, so it has to stay
// verified in Resend or every routine mail is refused at send.
export const brandAgentEmailDomain = `agents.${brandDomain}`;

// Each Instinct connection owns one address here; Resend receives the whole
// subdomain and the inbound webhook routes it away from the agent mail path.
export const brandCosMailDomain = `mail.${brandDomain}`;

export function brandEmailAddress(localPart: string): string {
  return `${localPart}@${brandDomain}`;
}

export function isBrandEmailAddress(address: string): boolean {
  return address.toLowerCase().endsWith(`@${brandDomain}`);
}
